"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useAsync_1 = __importDefault(require("react-use/lib/useAsync"));
const qs_1 = __importDefault(require("qs"));
const env_1 = __importDefault(require("../env"));
exports.default = (params, { endpoint = env_1.default.SEARCH_ENDPOINT } = {}) => {
    const url = `${endpoint}/search/suggest?${qs_1.default.stringify(params)}`;
    return (0, useAsync_1.default)(async () => {
        return await fetch(url).then(r => r.json());
    }, [url]);
};
//# sourceMappingURL=useSuggest.js.map